import { render, staticRenderFns } from "./RegistrationModuleDisclaimer.vue?vue&type=template&id=357035de"
import script from "./RegistrationModuleDisclaimer.vue?vue&type=script&lang=js"
export * from "./RegistrationModuleDisclaimer.vue?vue&type=script&lang=js"
import style0 from "./RegistrationModuleDisclaimer.vue?vue&type=style&index=0&id=357035de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports